<script lang="ts">
	import type { ClassValue } from "svelte/elements";
	import type { Attachment } from "@core/schema/Attachment.js";
	import { getUploadedFileExtension } from "@core/utils/getUploadedFileExtension.js";
	import { getUploadedFilePath } from "@core/utils/getUploadedFilePath.js";
	import { getGlobalSettings } from "../../contexts/getGlobalSettings.js";

	const { attachments, class: customClass }: { attachments: Attachment[]; class?: ClassValue } = $props();

	const { FILE_BUCKET_URL_MAP } = getGlobalSettings();
</script>

{#if attachments.length > 0}
	<div class={["flex flex-col gap-3", customClass]}>
		{#each attachments as attachment (attachment.path)}
			{@const fileName = `${attachment.title}.${getUploadedFileExtension(attachment)}`}
			<a
				href={getUploadedFilePath(attachment, FILE_BUCKET_URL_MAP)}
				download={fileName}
				class="flex items-center gap-3 p-3 bg-white rounded-lg hover:shadow-md transition-shadow border border-ivory-200"
				target="_blank"
			>
				<svg class="w-6 h-6 text-hazelnut-600 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
					<path
						fill-rule="evenodd"
						d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
						clip-rule="evenodd"
					/>
				</svg>
				<span class="flex-1 text-sm font-medium text-[#262626]">{fileName}</span>
			</a>
		{/each}
	</div>
{/if}
